import { j as n, c as s } from "./utils-BdNIfrGQ.js";
import { n as i } from "./normalize-spacing-DY0KSpr_.js";
import { c as o } from "./index-Di82Y7n3.js";
const c = o("flex items-center w-full py-4 px-5", {
  variants: {
    background: {
      default: "bg-background text-background-text",
      transparent: "bg-transparent text-inherit",
      inherit: "bg-inherit text-background-text"
    }
  },
  defaultVariants: {
    background: "transparent"
  }
}), m = ({ children: t, spacing: a, background: r, ...e }) => /* @__PURE__ */ n.jsx("header", { className: s(i(a), c({ background: r })), ...e, children: t });
export {
  m as H
};
